/**
 * @author David Beentjes
 * @company MDL Online
 * @copyright Copyright (c) 2019 MDL Online (https://mdlonline.nl)
 * @package Gebufa_pasvormautomatten
 */

define(function () {
    "use strict";

    // Overridden to disable this file
});
